import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import LinkButton from 'flarum/common/components/LinkButton';
export default function addNavLink() {
  // In champis-species' "Espèces" header menu (SpeciesToolsMenu) since
  // 2026-10-05, the user menu before. A string path: that menu is
  // champis-species', there only while that extension is.
  //
  // Just a UX convenience for hiding the link from actors who can't use it
  // anyway - the actual security boundary is each endpoint's own scope()/
  // Policy check, not this. One entry point only - ExhibitionsListPage
  // itself now also lists every société (see that page's own docblock),
  // so there's no separate "Sociétés" nav link anymore.
  extend('ext:champis/species/forum/components/SpeciesToolsMenu', 'items', function (items) {
    if (app.session.user && app.forum.attribute('canAccessExhibitions')) {
      items.add('exhibitions', m(LinkButton, {
        icon: "fas fa-campground",
        href: app.route('exhibitions')
      }, app.translator.trans('champis-exhibitions.forum.nav.exhibitions_link')), 10);
    }
  });
}